import { HiOutlineLockClosed } from "react-icons/hi2";


export const NotAuthorizedCard = ({ onBack }) => (
  <div className="min-h-[70vh] flex items-center justify-center px-4">
    <div className="w-full max-w-xl bg-white rounded-2xl shadow-xl p-8 text-center border border-gray-100">
      <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-5 bg-red-50">
        <HiOutlineLockClosed className="w-8 h-8 text-red-500" />
      </div>
      <h2 className="text-2xl md:text-3xl font-bold tracking-tight mb-2">Access restricted</h2>
      <p className="text-gray-600 leading-relaxed">
        You’re not privileged to access this form. Please contact your administrator if you believe this is a mistake.
      </p>

      <div className="mt-6 flex items-center justify-center gap-3">
        <button
          onClick={onBack}
          className="inline-flex items-center justify-center rounded-lg px-4 py-2.5 bg-[#0A0D36] text-white hover:opacity-90 transition"
        >
          Go back
        </button>
        <a
          href="/"
          className="inline-flex items-center justify-center rounded-lg px-4 py-2.5 border border-gray-300 text-gray-700 hover:bg-gray-50 transition"
        >
          Home
        </a>
      </div>

      <div className="mt-4 text-xs text-gray-500">
        If you need access across branches, ask for a role with cross-branch privileges.
      </div>
    </div>
  </div>
);

